<!-- Modal.vue -->
<template>
    <div>
        <dialog
            :open="isOpen"
            :class="{ 'modal-open': isOpen }"
            class="modal modal-middle items-center justify-center"
        >
            <div class="w-full flex justify-center">
                <div class="modal-box modal-box--contained mx-auto self-center" :class="containerClass">
                    <slot></slot>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        containerClass: {
            type: String,
            default: '',
        },
    },
};
</script>

<style>
.modal-box--contained {
    overflow-x: hidden;
    overflow-y: auto;
}
.modal-box--contained > * {
    min-width: 0;
    max-width: 100%;
}
.modal-box--contained .vtl {
    min-width: 0;
    width: 100%;
}
.modal-box--contained .vtl-card-body {
    min-width: 0;
    width: 100%;
}
.modal-box--contained .vtl-card-body > .vtl-row {
    min-width: 0;
    width: 100%;
}
.modal-box--contained .vtl-card-body > .vtl-row > .col-sm-12 {
    min-width: 0;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.modal-box--contained .vtl-table {
    min-width: 520px;
}
</style>
